import { marked } from 'marked';
import DOMPurify from 'dompurify';

/**
 * Parses and sanitizes a given markdown string to output safe HTML.
 * 
 * This function processes the input text by first cleaning up specific formatting 
 * (like removing '```markdown' blocks), converting the cleaned markdown into raw HTML 
 * using the `marked` library, and finally sanitizing that HTML via `DOMPurify` 
 * to mitigate Cross-Site Scripting (XSS) vulnerabilities.
 * 
 * @param {string} markdownText - The raw markdown string to be parsed and sanitized.
 * @returns {string} A sanitized HTML string that is safe to be rendered in the DOM.
 */
export function parseAndSanitizeMarkdown(markdownText) {
  if (!markdownText) {
    return '';
  }

  let cleanedText = markdownText.replace(/```markdown/gi, "```").replace(/markdown/gi, "");

  // Convert markdown to HTML using the 'marked' library.
  const rawHtml = marked.parse(cleanedText);

  // Sanitize the generated HTML to prevent XSS attacks before rendering.
  const sanitizedHtml = DOMPurify.sanitize(rawHtml);

  return sanitizedHtml;
}